import { render } from "./itemIndex.vue?vue&type=template&id=dc15adf4"
import script from "./itemIndex.vue?vue&type=script&lang=js"
export * from "./itemIndex.vue?vue&type=script&lang=js"

import "./itemIndex.vue?vue&type=style&index=0&id=dc15adf4&lang=scss"

import exportComponent from "D:\\JYC\\产品源码\\前端\\工作流引擎\\stgd.oa.mobile.h5\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__